import IndividualMetricsChange from './IndividualMetricsChange';

export default IndividualMetricsChange;
